"use client";

import React from "react";
import { Coffee } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutBluvit() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="über-bluvit" className="bg-white ![padding:144px_0px_144px_0px] overflow-hidden">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>

{/* Header - Two Column Layout */}
<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16 md:mb-20">
  <div>
    <span className="text-sm font-semibold uppercase tracking-widest text-[#888888] mb-4 block">Über uns</span>
    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
      <span className="text-[#141414]">Eine Treppe über dir.</span><br />
      <span className="text-[#888888]">Immer da.</span>
    </h2>
  </div>
  <div className="flex items-end">
    <p className="text-lg text-[#555555] leading-relaxed">
      Coworking Kassel ist kein Franchise. Kein Investorenprojekt. Hinter allem steckt BLUVIT — und wir arbeiten direkt im selben Gebäude.
    </p>
  </div>
</div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {/* Left: Image */}
        <div className="rounded-2xl overflow-hidden min-h-[500px]">
          <img src="https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/94-Bluvit_CoWorkingSpace_05052025_sandraschumann_0021.jpg" alt="BLUVIT Team beim gemeinsamen Kaffee" className="w-full h-full object-cover" />
        </div>

        {/* Right: Text */}
        <div className="rounded-2xl bg-white[#FF6F61] backdrop-blur-sm p-10 md:p-14 transition-all duration-300 hover:bg-white hover:shadow-lg flex flex-col justify-center">
          <div className="mb-8 flex h-12 w-12 items-center justify-center rounded-xl bg-[#FF6F61]/10">
            <Coffee className="size-6 text-[#FF6F61]" strokeWidth={1.5} />
          </div>
          <div className="space-y-5">
            <p className="text-lg leading-relaxed text-[#555555]">
              Wenn etwas nicht läuft, musst du kein Ticket aufmachen. Du klopfst einfach kurz.
            </p>
            <p className="text-lg leading-relaxed text-[#555555]">
              Wir sind keine Vermieter, die einmal im Monat die Miete einziehen. Wir sind Leute, die du morgens in der Küche triffst. Die wissen, wie die Kaffeemaschine tickt. Und die sich freuen, wenn der Space lebt.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>;
}